module.exports = function() {
  return new Worker(__webpack_public_path__ + "ac41a80007408b17c161.worker.js");
};